import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "customer-basket"
};
var _hoisted_2 = {
  class: "d-flex fl-col fl-s-b aside-wrapper"
};
var _hoisted_3 = {
  class: "order-summary-wrapper d-flex fl-col fl-s-b scroll-y"
};
var _hoisted_4 = {
  class: "scroll-y order-summary d-flex fl-col fl-s-b"
};
var _hoisted_5 = {
  class: "upper-part-container d-flex flex-row fl-s-b"
};
var _hoisted_6 = {
  class: "title d-flex fl-col fl-j-c"
};
var _hoisted_7 = {
  class: "assign-customer-btn-container d-flex flex-row fl-s-b flex-align-center"
};
var _hoisted_8 = {
  class: "icon-container"
};
var _hoisted_9 = {
  class: "max-content-width"
};
var _hoisted_10 = {
  class: "pss-list-container d-flex fl-col fl-s-a"
};
var _hoisted_11 = {
  key: 0
};
var _hoisted_12 = {
  class: "pss-container d-flex flex-row fl-s-b"
};
var _hoisted_13 = {
  class: "ticket-name-container"
};
var _hoisted_14 = {
  class: "ticket-name"
};
var _hoisted_15 = {
  key: 0,
  class: "price-name"
};
var _hoisted_16 = {
  key: 1,
  class: "timeslot"
};
var _hoisted_17 = {
  key: 2,
  class: "seat"
};
var _hoisted_18 = {
  key: 3,
  class: "ticket-discount-info"
};
var _hoisted_19 = {
  class: "quantity-container"
};
var _hoisted_20 = {
  class: "unit-price-container"
};
var _hoisted_21 = {
  class: "total-price-container"
};
var _hoisted_22 = {
  key: 0,
  class: "tickets-status-container"
};
var _hoisted_23 = {
  key: 5
};
var _hoisted_24 = {
  key: 0,
  class: "confirmed-amount-container"
};
var _hoisted_25 = {
  key: 1,
  style: {
    "padding-top": "5.05vh"
  }
};
var _hoisted_26 = {
  class: "d-flex flex-row fl-s-b",
  style: {
    "width": "25%"
  }
};

var _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "d-flex fl-col fl-j-c"
}, null, -1);

var _hoisted_28 = {
  key: 2,
  style: {
    "border-top": "2px solid white"
  }
};
var _hoisted_29 = {
  class: "accountings-container d-flex flex-row fl-s-b"
};
var _hoisted_30 = {
  class: "title d-flex fl-col fl-j-c"
};
var _hoisted_31 = {
  class: "value d-flex fl-col fl-j-c"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$splitPayments;

  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("p", {
    class: _normalizeClass({
      'long-title': _ctx.isLongTitle,
      'max-content-width': !_ctx.isLongTitle
    })
  }, _toDisplayString(_ctx.$t("asideordersummary.title")), 3)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_SvgIcon, {
    iconContent: _ctx.iconContent,
    iconAlt: _ctx.iconAlt,
    iconStyle: _ctx.iconStyle
  }, null, 8, ["iconContent", "iconAlt", "iconStyle"])]), _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.getCustomerFullName), 1)])]), _createElementVNode("div", _hoisted_10, [_ctx.groupedPSSList ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedPSSList, function (pss) {
    return _openBlock(), _createElementBlock("div", {
      key: String(pss.uuid),
      class: _normalizeClass(pss.bookingStatus === _ctx.BookingStatus.Canceled ? 'cancelled-pss-container' : '')
    }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("p", _hoisted_14, _toDisplayString( // In case of a retail with only one option which is the default one we show category name
    pss.pssType === _ctx.PSSType[_ctx.PSSType.Retail] ? pss.optionName || pss.categoryName : pss.categoryName), 1), _ctx.showTicketInfo(pss) ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(pss.priceName), 1)) : _createCommentVNode("", true), _ctx.showTicketInfo(pss) ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.formatDateTime(pss.startDateTime)), 1)) : _createCommentVNode("", true), pss.seats && pss.seats.length ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(pss.seats.length > 1 ? "".concat(_ctx.t("field.seat"), ": ").concat(pss.seats.join(", ")) : "".concat(_ctx.t("field.seat"), ": ").concat(pss.seats[0])), 1)) : _createCommentVNode("", true), true || (_ctx.hasGenericDiscountAccountings(pss) || _ctx.isPSSConsideredInDiscount1(pss)) && !_ctx.isFreeTicket(pss) ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.getTicketDiscount1(pss)), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_19, [_createElementVNode("p", {
      class: _normalizeClass(["quantity", pss.bookingStatus === _ctx.BookingStatus.Canceled ? 'erased-tickets' : ''])
    }, " X" + _toDisplayString(pss.quantity), 3)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("p", {
      class: _normalizeClass(["unit-price", pss.bookingStatus === _ctx.BookingStatus.Canceled ? 'erased-tickets' : ''])
    }, _toDisplayString((_ctx.getPSSValue(pss) / 100).toFixed(2)), 3)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("p", {
      class: _normalizeClass(["total-price", pss.bookingStatus === _ctx.BookingStatus.Canceled ? 'erased-tickets' : ''])
    }, _toDisplayString((_ctx.getPSSValue(pss) / 100 * pss.quantity).toFixed(2)), 3)])]), (pss.bookingStatus === _ctx.BookingStatus.Confirmed || pss.bookingStatus === _ctx.BookingStatus.Canceled) && _ctx.isEditOrder ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("p", null, _toDisplayString(_ctx.getStatusTranslation(pss)), 1)])) : _createCommentVNode("", true)], 2);
  }), 128))])) : _createCommentVNode("", true), _ctx.isInPaymentStep && _ctx.hasAppliedDiscount && _ctx.isDiscountOnAllOrder ? (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "total-container discount-container",
    justify: "start"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 5,
        class: "total-container"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString("".concat(_ctx.$t("button.discount"), ":")), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 5,
        class: "total-container"
      }, {
        default: _withCtx(function () {
          var _ctx$selectedBooking;

          return [_createTextVNode(_toDisplayString((_ctx$selectedBooking = _ctx.selectedBooking) === null || _ctx$selectedBooking === void 0 ? void 0 : _ctx$selectedBooking.currency), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 11,
        class: "d-flex flex-row fl-a-c fl-j-e"
      }), _createVNode(_component_el_col, {
        class: "total-container text-right",
        span: 3
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString((_ctx.discountTotal1 / 100).toFixed(2)), 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  })) : _createCommentVNode("", true), _ctx.isInPaymentStep || _ctx.isCompletedBooking ? (_openBlock(), _createBlock(_component_el_row, {
    key: 2,
    justify: "start"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        class: "total-container",
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString("".concat(_ctx.$t("field.subtotal"), ":")), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        class: "total-container pl-20 pr-20",
        span: 13
      }, {
        default: _withCtx(function () {
          var _ctx$selectedBooking2;

          return [_createTextVNode(_toDisplayString((_ctx$selectedBooking2 = _ctx.selectedBooking) === null || _ctx$selectedBooking2 === void 0 ? void 0 : _ctx$selectedBooking2.currency), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        class: "total-container text-right",
        span: 3
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString((Number(_ctx.total1) - Number(_ctx.totalTax)).toFixed(2)), 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  })) : _createCommentVNode("", true), _ctx.isInPaymentStep || _ctx.isCompletedBooking ? (_openBlock(), _createBlock(_component_el_row, {
    key: 3,
    class: "tax-container",
    justify: "start"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        class: "total-container",
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString("".concat(_ctx.$t("field.vat"), ":")), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        class: "total-container pl-20 pr-20",
        span: 13
      }, {
        default: _withCtx(function () {
          var _ctx$selectedBooking3;

          return [_createTextVNode(_toDisplayString((_ctx$selectedBooking3 = _ctx.selectedBooking) === null || _ctx$selectedBooking3 === void 0 ? void 0 : _ctx$selectedBooking3.currency), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        class: "total-container text-right",
        span: 3
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.totalTax), 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  })) : _createCommentVNode("", true), (_ctx.isInPaymentStep || _ctx.isCompletedBooking) && !_ctx.isEditOrder ? (_openBlock(), _createBlock(_component_el_row, {
    key: 4,
    justify: "start"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        class: "total-container",
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString("".concat(_ctx.$t("field.total"), ":")), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        class: "total-container pl-20 pr-20",
        span: 13
      }, {
        default: _withCtx(function () {
          var _ctx$selectedBooking4;

          return [_createTextVNode(_toDisplayString((_ctx$selectedBooking4 = _ctx.selectedBooking) === null || _ctx$selectedBooking4 === void 0 ? void 0 : _ctx$selectedBooking4.currency), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        class: "total-container text-right",
        span: 3
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.total1), 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  })) : _createCommentVNode("", true), (_ctx.isInPaymentStep || _ctx.isCompletedBooking) && !_ctx.isEditOrder && (_ctx$splitPayments = _ctx.splitPayments) !== null && _ctx$splitPayments !== void 0 && _ctx$splitPayments.length ? (_openBlock(), _createElementBlock("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currenciesUsedInPayment, function (currency, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [currency && currency.label !== _ctx.groupCurrency.label ? (_openBlock(), _createBlock(_component_el_row, {
      key: 0,
      justify: "start"
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_el_col, {
          class: "total-container",
          span: 8
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString("".concat(_ctx.$t("field.total"), ":")), 1)];
          }),
          _: 1
        }), _createVNode(_component_el_col, {
          class: "total-container pl-20 pr-20",
          span: 4
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(currency.label), 1)];
          }),
          _: 2
        }, 1024), _createVNode(_component_el_col, {
          class: "total-container text-center",
          span: 9
        }, {
          default: _withCtx(function () {
            return [_createTextVNode("R " + _toDisplayString(currency.exchangeRate), 1)];
          }),
          _: 2
        }, 1024), _createVNode(_component_el_col, {
          class: "total-container text-right",
          span: 3
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString((Number(_ctx.total1) * currency.exchangeRate).toFixed(2)), 1)];
          }),
          _: 2
        }, 1024)];
      }),
      _: 2
    }, 1024)) : _createCommentVNode("", true)]);
  }), 128))])) : _createCommentVNode("", true), _ctx.isEditOrder ? (_openBlock(), _createBlock(_component_el_row, {
    key: 6,
    justify: "start"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        class: "total-container",
        span: 5
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString("".concat(_ctx.$t("field.total"), ":")), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        class: "total-container pl-20 pr-20",
        span: 16
      }, {
        default: _withCtx(function () {
          var _ctx$selectedBooking5;

          return [_createTextVNode(_toDisplayString((_ctx$selectedBooking5 = _ctx.selectedBooking) === null || _ctx$selectedBooking5 === void 0 ? void 0 : _ctx$selectedBooking5.currency), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        class: "total-container text-right",
        span: 3
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.orderValueExcludingCancelledTickets), 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  })) : _createCommentVNode("", true)]), false ? (_openBlock(), _createElementBlock("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.confirmedAmountsInfo, function (info) {
    return _openBlock(), _createBlock(_component_el_row, {
      justify: "start",
      align: "middle",
      key: info.confirmedAmount,
      class: "confirmed-amount"
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_el_col, {
          span: 10
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(info.accountingInfo.paymentTool), 1)];
          }),
          _: 2
        }, 1024), _createVNode(_component_el_col, {
          span: 11,
          class: "d-flex flex-row fl-a-c fl-j-e"
        }), _createVNode(_component_el_col, {
          class: "text-right",
          span: 3
        }, {
          default: _withCtx(function () {
            var _ctx$selectedBooking6;

            return [_createTextVNode(_toDisplayString((_ctx$selectedBooking6 = _ctx.selectedBooking) === null || _ctx$selectedBooking6 === void 0 ? void 0 : _ctx$selectedBooking6.currency), 1)];
          }),
          _: 1
        }), _createVNode(_component_el_col, {
          class: _normalizeClass(["text-right", {// 'confirmed-hundreds': info.confirmedAmount > 99,
            // 'confirmed-ones': info.confirmedAmount < 99,
          }]),
          span: 3
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(info.confirmedAmount.toFixed(2)), 1)];
          }),
          _: 2
        }, 1024)];
      }),
      _: 2
    }, 1024);
  }), 128))])) : _createCommentVNode("", true), _ctx.splitPayments && _ctx.splitPayments.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitPayments, function (payment) {
    var _payment$currency;

    return _openBlock(), _createElementBlock("div", {
      key: payment.method,
      class: "d-flex fl-row fl-s-b amounts-paid",
      style: {
        "min-height": "25px"
      }
    }, [_createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(payment.translatedMethod), 1)]), _createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString((_payment$currency = payment.currency) === null || _payment$currency === void 0 ? void 0 : _payment$currency.label), 1)]), _createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(payment.cashBill ? payment.cashBill.toFixed(2) : (payment.amount * (payment.exchangeRate || 1)).toFixed(2)), 1)])])]);
  }), 128))])) : _createCommentVNode("", true), _ctx.splitPayments && _ctx.splitPayments.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_el_row, {
    justify: "start",
    style: {
      "margin-bottom": "-1.89vh"
    }
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 9,
        class: "confirmed-amount-total"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("asideordersummary.amount-confirmed")), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 12,
        class: "confirmed-amount-total"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.payingCurrency), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 3,
        class: _normalizeClass(['confirmed-amount-total text-right'])
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString((_ctx.amountPaid / 100).toFixed(2)), 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _ctx.isEditOrder ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    justify: "start"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 9,
        class: "confirmed-amount-total"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("asideordersummary.amount-refunded")), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 12,
        class: "confirmed-amount-total"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.payingCurrency), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 3,
        class: _normalizeClass(['confirmed-amount-total text-right'])
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.refundedAmount.toFixed(2)), 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_29, [_createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.$t("asideordersummary.balance-in")) + " " + _toDisplayString(_ctx.currency), 1), _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.whatIsLeftToPay), 1)])])])])]);
}